import baseAPI from '@/api/base';
import { EditTicketComment, GetTicketComment, AddTicketComment } from '../dtos/ticket_comment.dto';
import { DELETE_TICKET_COMMENT_URL, TICKET_COMMENT_URL, EDIT_TICKET_COMMENT_URL, ADD_TICKET_COMMENT_URL } from '@/utils/urls';
import { ticketFormData, TICKET_REQUEST_PARAMS, UPLOAD_REQUEST_CONFIG } from '@/utils/ticket';
import { AxiosResponse } from 'axios';

// Every request says who is asking (utils/ticket TICKET_REQUEST_PARAMS), as
// services/ticket's do. The same module lives in the admin and in both
// organization apps.
const params = (extra?: object) => ({ ...TICKET_REQUEST_PARAMS, ...(extra || {}) });

class TicketComment {
    /** The conversation, with the ticket as it stands for the signed-in side: `{ ticket, comments }`. */
    static getTicketComment = async(getTicketComment: GetTicketComment) : Promise<AxiosResponse> => {
        return baseAPI.get(TICKET_COMMENT_URL, {
            params: params({ ...getTicketComment, include: 'ticket' })
        })
    }

    // A multipart form, so the files go with the message.
    static registerTicketComment = async(registerTicketComment: AddTicketComment) : Promise<AxiosResponse> => {
        const { attachments, ...fields } = registerTicketComment;
        return baseAPI.post(ADD_TICKET_COMMENT_URL, ticketFormData(fields, attachments), { ...UPLOAD_REQUEST_CONFIG, params: params() })
    }

    static editTicketComment = async(editTicketComment: EditTicketComment) : Promise<AxiosResponse> => {
        return baseAPI.put(EDIT_TICKET_COMMENT_URL, {
            ...editTicketComment
        }, { params: params() })
    }

    static deleteTicketComment = async(ticketCommentId: string) : Promise<AxiosResponse> => {
        return baseAPI.delete(`${DELETE_TICKET_COMMENT_URL}/${encodeURIComponent(ticketCommentId)}`, { params: params() })
    }
}

export default TicketComment
